import {
  HierarchicalOrganizationalUnit,
  OrganizationalUnit,
  UpdateOrganizationalUnit
} from '../types/OrganizationalUnit';
import {handleError} from '../../../common/utils/errorHandling';
import httpClient from '../../../common/services/httpClient';

class OrganizationalUnitsService {
  public async getAllOrganizationalUnits(): Promise<OrganizationalUnit[]> {
    return handleError(
      () => httpClient.get<OrganizationalUnit[]>('/organizational-units'),
      'Error fetching organizational units:',
      () => []
    );
  }

  public async getOrganizationalUnitsByHierarchyType(hierarchyType: string): Promise<OrganizationalUnit[]> {
    return handleError(
      () => httpClient.get<OrganizationalUnit[]>(`/organizational-units/hierarchy/${hierarchyType}`),
      'Error fetching organizational units by hierarchy type:',
      () => []
    );
  }

  public async getOrganizationalUnit(id: string): Promise<OrganizationalUnit> {
    return handleError(
      () => httpClient.get<OrganizationalUnit>(`/organizational-units/${id}`),
      'Error fetching organizational unit:'
    );
  }

  public async createOrganizationalUnit(unit: Omit<UpdateOrganizationalUnit, 'id'>): Promise<void> {
    const unitWithId = {
      ...unit,
      id: crypto.randomUUID()
    };
    return handleError(
      () => httpClient.post<void>('/organizational-units', unitWithId),
      'Error creating organizational unit:'
    );
  }

  public async updateOrganizationalUnit(unit: UpdateOrganizationalUnit): Promise<void> {
    return handleError(
      () => httpClient.put<void>(`/organizational-units/${unit.id}`, unit),
      'Error updating organizational unit:'
    );
  }

  public async deleteOrganizationalUnit(id: string): Promise<void> {
    return handleError(
      () => httpClient.delete<void>(`/organizational-units/${id}`),
      'Error deleting organizational unit:'
    );
  }

  public async getHierarchicalOrganizationalUnitsByType(hierarchyType: string): Promise<HierarchicalOrganizationalUnit[]> {
    return handleError(
      () => httpClient.get<HierarchicalOrganizationalUnit[]>(`/organizational-units/hierarchy/${hierarchyType}/paths`),
      'Error fetching hierarchical organizational units:',
      () => []
    );
  }

  public async getHierarchicalOrganizationalUnit(id: string): Promise<HierarchicalOrganizationalUnit> {
    return handleError(
      () => httpClient.get<HierarchicalOrganizationalUnit>(`/organizational-units/${id}/path`),
      'Error fetching hierarchical organizational unit:'
    );
  }
}

const organizationalUnitsService = new OrganizationalUnitsService();
export default organizationalUnitsService;
